export default "__VITE_ASSET__Ck7P6szR__"